import React from "react";
import { Id } from "@planzone/dto";

const Context = React.createContext<{
  toggled: { [key: string]: boolean };
  open(id: Id): void;
  close(id: Id): void;
}>({
  toggled: {},
  open(id: Id) {},
  close(id: Id) {},
});

function useToggle(id: Id, isOpenByDefault: boolean = false) {
  const ctx = React.useContext(Context);
  const isInitialized = typeof ctx.toggled[id] !== "undefined";
  const isOpen = !isInitialized ? isOpenByDefault : ctx.toggled[id];

  ctx.toggled[id] = isOpen;

  return {
    isOpen,
    toggle: () => (isOpen ? ctx.close(id) : ctx.open(id)),
  };
}

export { Context, useToggle };
